module.exports = __webpack_public_path__ + "static/img/naves-industriales-mexico1.4939ed5.jpg";